export const redirectToHttps = () => {
    const domain = window.location.hostname;
    if(domain !== 'localhost'){
        let url = window.location.href;
        if(!url.includes('https')){
            url = url.replace('http', 'https');
            window.location.href = url;
        }
    }
};

// Environment configuration with shared and environment-specific variables
const GlobalConfig = {
    /** API Key for the API */
    API_KEY: process.env.REACT_APP_API_KEY,
    /** Document API Key for the API */
    DOCUMENT_API_KEY: process.env.REACT_APP_DOCUMENT_API_KEY,
    APP_NAME: process.env.REACT_APP_NAME || '',
};
const EnvironmentConfigs = {
    development: {
        API_URL: process.env.REACT_APP_API_URL,
        ATHOS_DOT_NET_URL: process.env.REACT_APP_DOT_NET_URL,
    },
    staging: {
        API_URL: process.env.REACT_APP_API_URL,
        ATHOS_DOT_NET_URL: process.env.REACT_APP_DOT_NET_URL,
    },
    // uat: {},
    production: {
        API_URL: process.env.REACT_APP_API_URL,
        ATHOS_DOT_NET_URL: process.env.REACT_APP_DOT_NET_URL,
    },
};
const ExternalConfigs = {
    GOOGLE_PLACES_API_KEY: process.env.REACT_APP_GOOGLE_PLACES_API,
};

export const Environments = Object.freeze({
    development: 'development',
    staging: 'staging',
    uat: 'uat',
    production: 'production',
});

// Helper function to get config values
export const getConfig = (key) => config[key];

export const getEnv = () => {
    // const domain = window.location.hostname;
    // if(domain === 'localhost'){
    //     return Environments.development;
    // }
    return process.env.REACT_APP_ENV;
};
// Helper function to check if we're in a specific environment
export const isEnv = (env) => {
    const domain = window.location.hostname;
    if(domain === 'localhost'){
        return Environments.development === env;
    }
    return process.env.REACT_APP_ENV === env;
};
export const isDevelopment = () => isEnv('development');
export const isStaging = () => isEnv('staging');
export const isProduction = () => isEnv('production'); 

/**
 * @typedef {Object} Config
 * @property {string} ENV - The environment name
 * @property {string} API_KEY - The API key
 * @property {string} DOCUMENT_API_KEY - The document API key
 * @property {string} APP_NAME - The app name
 * @property {string} API_URL - The API URL
 * @property {string} ATHOS_DOT_NET_URL - The Athos .NET URL
 * @property {string} GOOGLE_PLACES_API_KEY - The Google Places API key
 */

/** The configuration object for the application
 * @type {Config}
 */
export const config = {
    // ENV: 'STAGING',
    ENV: getEnv(),
    ...GlobalConfig,
    ...EnvironmentConfigs[getEnv()],
    ...ExternalConfigs,
};